import { render, staticRenderFns } from "./AppRegisterLayout.vue?vue&type=template&id=ab6bf580&"
import script from "./AppRegisterLayout.vue?vue&type=script&lang=js&"
export * from "./AppRegisterLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports